var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C5.45 6 5 5.55 5 5C5 4.45 5.45 4 6 4C6.55 4 7 4.45 7 5C7 5.55 6.55 6 6 6ZM9 5.1C9 3.285 7.675 2 6 2C4.325 2 3 3.285 3 5.1C3 6.27 3.975 7.82 6 9.67C8.025 7.82 9 6.27 9 5.1ZM6 1C8.1 1 10 2.61 10 5.1C10 6.76 8.665 8.725 6 11C3.335 8.725 2 6.76 2 5.1C2 2.61 3.9 1 6 1Z",
    fill: "#0B89CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg7);
export default __webpack_public_path__ + "static/media/svg7.99661c4d5b94af53352cc53b95fcd413.svg";
export { ForwardRef as ReactComponent };